// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/bidding_spot_market_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { BiddingSpotMarketKomaPrices } from "./bidding_spot_market_model_pb";
import { file_bffuser_v1_bidding_spot_market_model } from "./bidding_spot_market_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/bidding_spot_market_service.proto.
 */
export const file_bffuser_v1_bidding_spot_market_service: GenFile = /*@__PURE__*/
  fileDesc("CixiZmZ1c2VyL3YxL2JpZGRpbmdfc3BvdF9tYXJrZXRfc2VydmljZS5wcm90bxIKYmZmdXNlci52MSKQAQoiTGlzdEJpZGRpbmdTcG90TWFya2V0UHJpY2VzUmVxdWVzdBI1ChJkZWxpdmVyeV9kYXRlX2Zyb20YASABKAsyES5nb29nbGUudHlwZS5EYXRlQga6SAPIAQESMwoQZGVsaXZlcnlfZGF0ZV90bxgCIAEoCzIRLmdvb2dsZS50eXBlLkRhdGVCBrpIA8gBASJjCiNMaXN0QmlkZGluZ1Nwb3RNYXJrZXRQcmljZXNSZXNwb25zZRI8Cgtrb21hX3ByaWNlcxgBIAMoCzInLmJmZnVzZXIudjEuQmlkZGluZ1Nwb3RNYXJrZXRLb21hUHJpY2VzMp0BChhCaWRkaW5nU3BvdE1hcmtldFNlcnZpY2USgAEKG0xpc3RCaWRkaW5nU3BvdE1hcmtldFByaWNlcxIuLmJmZnVzZXIudjEuTGlzdEJpZGRpbmdTcG90TWFya2V0UHJpY2VzUmVxdWVzdBovLmJmZnVzZXIudjEuTGlzdEJpZGRpbmdTcG90TWFya2V0UHJpY2VzUmVzcG9uc2UiAEJAWj5naXRodWIuY29tL2VuZWNoYWluL2ViYWxhbmNlL2dvL2dlbi9wcm90by9iZmZ1c2VyL3YxO2JmZnVzZXJ2MWIGcHJvdG8z", [file_bffuser_v1_bidding_spot_market_model, file_buf_validate_validate, file_google_type_date]);

/**
 * @generated from message bffuser.v1.ListBiddingSpotMarketPricesRequest
 */
export type ListBiddingSpotMarketPricesRequest = Message<"bffuser.v1.ListBiddingSpotMarketPricesRequest"> & {
  /**
   * 受渡日の期間の開始日 (含む)。
   *
   * @generated from field: google.type.Date delivery_date_from = 1;
   */
  deliveryDateFrom?: Date;

  /**
   * 受渡日の期間の終了日 (含む)。 開始日から 31 日以内。
   *
   * @generated from field: google.type.Date delivery_date_to = 2;
   */
  deliveryDateTo?: Date;
};

/**
 * Describes the message bffuser.v1.ListBiddingSpotMarketPricesRequest.
 * Use `create(ListBiddingSpotMarketPricesRequestSchema)` to create a new message.
 */
export const ListBiddingSpotMarketPricesRequestSchema: GenMessage<ListBiddingSpotMarketPricesRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_market_service, 0);

/**
 * @generated from message bffuser.v1.ListBiddingSpotMarketPricesResponse
 */
export type ListBiddingSpotMarketPricesResponse = Message<"bffuser.v1.ListBiddingSpotMarketPricesResponse"> & {
  /**
   * 受渡日の昇順・コマ番号の昇順。
   *
   * @generated from field: repeated bffuser.v1.BiddingSpotMarketKomaPrices koma_prices = 1;
   */
  komaPrices: BiddingSpotMarketKomaPrices[];
};

/**
 * Describes the message bffuser.v1.ListBiddingSpotMarketPricesResponse.
 * Use `create(ListBiddingSpotMarketPricesResponseSchema)` to create a new message.
 */
export const ListBiddingSpotMarketPricesResponseSchema: GenMessage<ListBiddingSpotMarketPricesResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_market_service, 1);

/**
 * スポット市場の約定価格 (システムプライス・エリアプライス) を frontend 向けに提供する service
 * (docs/specs/bidding/spot-bidding.md §5 スポット約定価格)。 閲覧専用。
 * 市場データは全社共通のため organization_id を持たない。
 * 認証は interceptor 任せ。
 *
 * @generated from service bffuser.v1.BiddingSpotMarketService
 */
export const BiddingSpotMarketService: GenService<{
  /**
   * 受渡日の期間 (開始日・終了日とも含む) の約定価格を、 受渡日の昇順・コマ番号の昇順で返す。
   * 期間は開始日から 31 日以内。 取得に失敗した時は空の一覧にせずエラーを返す。
   *
   * @generated from rpc bffuser.v1.BiddingSpotMarketService.ListBiddingSpotMarketPrices
   */
  listBiddingSpotMarketPrices: {
    methodKind: "unary";
    input: typeof ListBiddingSpotMarketPricesRequestSchema;
    output: typeof ListBiddingSpotMarketPricesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_bidding_spot_market_service, 0);

